import React from 'react'
import { ILeadOppProduct } from '@user/store/leadOppProducts'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import { getStyles } from './hooks/useStyles'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

type Props = {
  leadOppProduct: ILeadOppProduct
}

const ServiceDraggableCard = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { leadOppProduct } = props
    const { name, description } = leadOppProduct
    const styles = getStyles(useTheme())
    const theme = useTheme()

    return (
      <Box ref={ref} sx={styles.draggable}>
        <Box sx={styles.row}>
          <Box sx={styles.actionContainer}>
            <Stack direction="row" pl={1.5}>
              <DragIndicatorIcon sx={{ cursor: 'grab' }} fontSize="small" />
              <Box style={{ paddingLeft: theme.spacing(1.5) }}>
                <Typography>
                  {name} - {description}
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    )
  },
)

export { ServiceDraggableCard }
